// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.welcome {
  width: -moz-fit-content;
  width: fit-content;
  position: absolute;
  right: 100px;
  margin-top: 10px;
  margin-right: 30px;
  height: 80px;
  white-space: nowrap;
}

@media (max-width: 992px) {
  .welcome {
    margin-right: 0;
    right: 90px;
    font-size: 18px;
  }
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
